import React from "react";

const Redirect = () => {
  return <>REDIRECT PAGE</>;
};

export default Redirect;
